// removed by extract-text-webpack-plugin
module.exports = {"label":"index__label___2Ogd_","select":"index__select___1OZQ6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/StyledSelect/index.less
// module id = 1230
// module chunks = 3